import "../../styles/notification/notification.css";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { updateNotification } from "../../slice/notificationSlice";
import { useEffect, useLayoutEffect, useState } from "react";
import { setUser } from "../../slice/webStoreUserSlice";
import { editProfileURL } from "../../api/endpoints";
import { navBarLogo } from "../../components/narbar/Narbar";
import NotificationSkeleton from "../../components/uxCollections/skeletonLoader/notification/NotificationSkeleton";

const Notification = ({ setShowNotification }) => {
  const [notificationList, setNotificationList] = useState([]); //
  const [unReadNotificationCount, setUnReadNotificationCount] = useState(null); //
  const [loading, setLoading] = useState(true); // Loading state for notifications
  const { user } = useSelector((state) => state.webStoreUser);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNotification(false));
    //  refetchUser();
    populateNotificationList(user);
    setLoading(false);
  }, []);

  const refetchUser = async () => {
    try {
      let response = await fetch(editProfileURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.ok) {
        let data = await response.json();
        dispatch(setUser(data));
        console.log(data.notifications.slice(0).reverse());
        setNotificationList(data.notifications.slice(0).reverse());
        let count = 0;
        data.notifications.forEach((notification) => {
          if (notification.newNotification) {
            count++;
          }
        });
        setUnReadNotificationCount(count ? count : null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const populateNotificationList = (user) => {
    setNotificationList(user.notifications.slice(0).reverse());
    let count = 0;
    user.notifications.forEach((notification) => {
      if (notification.newNotification) {
        count++;
      }
    });
    setUnReadNotificationCount(count ? count : null);
  };

  return (
    <>
      {
        <div onClick={() => setShowNotification(false)} className='notificationWrapper'>
          <div onClick={(e) => e.stopPropagation()} className='notificationDiv2'>
            {loading ? (
              <NotificationSkeleton />
            ) : (
              <>
                <div className='notificationTitileDiv'>
                  <h4>Notification</h4>
                  {unReadNotificationCount && <div>{unReadNotificationCount} </div>}
                  <span onClick={() => setShowNotification(false)}>
                    <IoClose />
                  </span>
                </div>

                {notificationList.map((notification, i) => {
                  return <EachNotification key={i} notification={notification} setUnReadNotificationCount={setUnReadNotificationCount} />;
                })}
              </>
            )}
          </div>
        </div>
      }
    </>
  );
};

export default Notification;

const EachNotification = ({ notification, setUnReadNotificationCount }) => {
  const [isUnRead, setIsUnRead] = useState(true);

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (notification.newNotification) {
      setIsUnRead(true);
    } else {
      setIsUnRead(false);
    }
  }, [notification.newNotification]);

  const updateNotification = async (id) => {
    if (notification.newNotification && isUnRead) {
      setUnReadNotificationCount((prev) => {
        if (prev > 1) {
          return prev - 1;
        } else {
          return null;
        }
      });

      try {
        let response = await fetch(editProfileURL, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify({
            notificationID: id,
          }),
        });
        if (response.ok) {
          let data = await response.json();
          console.log(data);
          dispatch(setUser(data));
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const computeTimeFromNow = (date) => {
    let now = new Date();
    let notificationDate = new Date(date);
    let diff = now.getTime() - notificationDate.getTime();
    let diffInDays = diff / (1000 * 3600 * 24);
    let diffInHours = diff / (1000 * 3600);
    let diffInMinutes = diff / (1000 * 60);
    let diffInSeconds = diff / 1000;
    if (diffInDays > 1) {
      return `${Math.floor(diffInDays)} days ago`;
    } else if (diffInHours > 1) {
      return `${Math.floor(diffInHours)} hours ago`;
    } else if (diffInMinutes > 1) {
      return `${Math.floor(diffInMinutes)} minutes ago`;
    } else {
      return `${Math.floor(diffInSeconds)} seconds ago`;
    }
  };

  let imageUrl =
    notification.notificationImage &&
    `${notification.notificationImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_60/${notification.notificationImage.split("/upload/")[1]}`;
  return (
    <>
      <div
        className={isUnRead ? "eachNotification unreadNotification" : "eachNotification"}
        onMouseOver={() => {
          setIsUnRead(false);
          updateNotification(notification._id);
        }}
      >
        <div className='ImageDivNoti3'>{notification.notificationImage ? <img loading='lazy' src={imageUrl} /> : navBarLogo}</div>
        <div>
          {" "}
          <p className='notificationMessage'>{notification.notification}</p>
          <span> {computeTimeFromNow(notification.notificationDate)} </span>
        </div>
      </div>
    </>
  );
};
